import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

import { ApiRepositoryService } from '#repositories/api-repository/api-repository.service';
import { IntermediaryService } from '#services/intermediary/intermediary.service';
import { HomeData, HomeDataResponse } from '#models/db/home/home.model';
import { logger } from '#lib/logger';
import { IHomeService } from './home.interface';

@Injectable({
  providedIn: 'root',
})
export class HomeService implements IHomeService {
  path = 'home-data';

  homeData$ = new BehaviorSubject<HomeData | null>(null);
  homeDataLoading$ = new Subject<boolean>();

  constructor(
    private apiRepository: ApiRepositoryService,
    private intermediaryHandler: IntermediaryService
  ) {}

  getHomeData(nextFn?: (data: HomeData | null) => void, silent?: boolean) {
    this.intermediaryHandler.intermediary(
      {
        loading: !silent ? this.homeDataLoading$ : undefined,
        subject: this.homeData$,
        nextFn,
      },
      async () => {
        const response = await this.apiRepository.get<HomeDataResponse>({ url: `${this.path}` });

        logger.log(response.details, 'HomeService.getHomeData -> response');

        return response.details;
      }
    );
  }

  resetHomeData() {
    this.homeData$.next(null);
    logger.log('complete', 'HomeService.resetHomeData');
  }
}
